var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5758",
    "data-name": "Group 5758",
    transform: "translate(-1612 -362)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_36",
    "data-name": "Ellipse 36",
    transform: "translate(1612 362)",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 23.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 22,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5757",
    "data-name": "Group 5757",
    transform: "translate(-0.098 -0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8699",
    "data-name": "Path 8699",
    d: "M10973.024-19732.738h28.563",
    transform: "translate(-20086.752 6569.553) rotate(45)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8700",
    "data-name": "Path 8700",
    d: "M10973.024-19732.738h28.563",
    transform: "translate(-4548.355 -21336.75) rotate(135)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.e3180ac038ebc9d5b61e594c223a7da0.svg";
export { ForwardRef as ReactComponent };